import React from 'react';
import { pick } from 'lodash';
import Select from 'react-select';

import TouristField from '../../TouristField';
import {
  DOC_TYPES,
  TOURIST_FIELDS as T,
  WRONG_FORMAT_MESSAGES,
} from '../../../../routes/Checkout/store/constants/tourists';
import { fuzzyMatch, equalsIgnoreCase } from '../../../../utils/stringUtils';
import TouristFieldInput from '../../TouristFieldInput';
import { blurActiveElement } from '../../../../routes/Checkout/utils/globalUtils';
import type { TouristNameProps } from '../types';
import TouristNameOption from './components/TouristNameOption';

const TOURIST_REQUIRED_FIELDS = [
  T.NAME,
  T.SURNAME,
  T.BIRTHDAY,
  T.DOC_NUMBER,
  T.CITIZENSHIP,
  T.GENDER,
];
const noop = () => null;

const SELECT_STYLE = {
  control: noop,
  container: (base) => ({ ...base, width: '100%' }),
  valueContainer: (base) => ({ ...base, padding: 0 }),
  menuList: (base) => ({ ...base, padding: 0, borderRadius: '4px' }),
  menu: (base) => ({
    ...base,
    width: 'auto',
    marginTop: '1rem',
    marginLeft: '-.5rem',
  }),
  option: (base) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    padding: 0,
    // !important to override :active styles
    backgroundColor: 'transparent !important',
  }),
};

const SELECT_STYLE_MOBILE = {
  ...SELECT_STYLE,
  container: (base) => ({ ...base, width: '100%' }),
  menu: (base) => ({
    ...base,
    width: 'calc(100% + 13px)',
    marginTop: '1rem',
    marginLeft: '-8px',
  }),
};

interface State {
  menuIsOpen: boolean;
}

class TouristName extends React.PureComponent<TouristNameProps, State> {
  constructor(props) {
    super(props);

    this.state = { menuIsOpen: false };
    this.showMenu = this.showMenu.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
    this.onTouristSelected = this.onTouristSelected.bind(this);
    this.filterFunc = this.filterFunc.bind(this);
    this.getInput = this.getInput.bind(this);
  }

  onTouristSelected(option) {
    const { onTouristSelect, docType, isMobile } = this.props;
    const fields = [...TOURIST_REQUIRED_FIELDS];
    const touristInfo = pick(option, fields);
    if (docType === DOC_TYPES.international_passport.id) {
      touristInfo.passport_expires_on = option.passport_expires_on;
    } else {
      touristInfo.patronymic = option.patronymic;
    }
    onTouristSelect(touristInfo);
    this.hideMenu();
    if (isMobile) {
      blurActiveElement();
    }
  }

  get patternFailedMessage() {
    const { stateField } = this.props;
    return WRONG_FORMAT_MESSAGES[stateField];
  }

  getInput() {
    const { docType, isMobile, value = '', ...rest } = this.props;
    const pattern = docType && DOC_TYPES[docType].pattern;

    return (
      <TouristFieldInput
        {...rest}
        value={value}
        onFocus={this.showMenu}
        onBlur={!isMobile ? this.hideMenu : undefined}
        pattern={pattern}
        patternFailedMessage={this.patternFailedMessage}
      />
    );
  }

  showMenu() {
    this.setState({ menuIsOpen: true });
  }

  hideMenu() {
    this.setState({ menuIsOpen: false });
  }

  filterFunc(option, value) {
    const {
      data: {
        name = undefined,
        surname = undefined,
        patronymic = undefined,
      } = {},
    } = option;
    const { docType } = this.props;
    const docTypeMatches = equalsIgnoreCase(docType, option.data.docType);
    return (
      docTypeMatches &&
      [name, surname, patronymic].some((field) => fuzzyMatch(field, value))
    );
  }

  render() {
    const { value, tourists, isMobile, deleteSavedTourist, ...other } =
      this.props;
    const { menuIsOpen } = this.state;

    const style = isMobile ? SELECT_STYLE_MOBILE : SELECT_STYLE;

    return (
      <TouristField {...other} value={value}>
        <Select
          menuIsOpen={!isMobile && menuIsOpen}
          // @ts-ignore
          styles={style}
          backspaceRemovesValue={false}
          tabSelectsValue={false}
          inputValue={value}
          components={{
            Input: this.getInput,
            Option: (props) => (
              // React-Select не очень дружит с typescript, когда прокидываешь дополнительные пропы в опшены
              // @ts-ignore
              <TouristNameOption
                isMobile={false}
                onClickOption={this.hideMenu}
                deleteSavedTourist={deleteSavedTourist}
                {...props}
              />
            ),
            IndicatorsContainer: noop,
            Placeholder: noop,
          }}
          onChange={this.onTouristSelected}
          filterOption={this.filterFunc}
          options={tourists}
          noOptionsMessage={noop}
        />
      </TouristField>
    );
  }
}

export default TouristName;
